<template>
  <div>
    <p class="mb-4">
      Клубы, которые участвуют в конкурсе, объединяются в группы.<br>
      Внутри одной группы может быть максимально 30 клубов.<br>
      Внутри одной группы клубы соревнуются между собой.
    </p>

    <table class="prop-table mb-2">
      <tr>
        <th>Group amount</th>
        <td class="text-right">
          {{stat.groupAmount | getFormattedNumber}}
        </td>
      </tr>
      <tr>
        <th>Total club amount (in all groups)</th>
        <td class="text-right">
          {{stat.clubAmount | getFormattedNumber}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TmntClubsStat',

  props: {
    stat: {
      type: Object,
      required: true,
    },
  },
};
</script>
